import React, { useState } from 'react';
import { StyledAvailabilityDiv, StyledAvailabilityFilterHeaderContainerDiv } from './index.styles';
// import { AmenitiesFiltersComponentsProps } from './../../index.types';
import { renderedData } from '../../organisms/OSearchResults/searchResultsMainComponent';
import { SearchFacetsConstants } from '../../organisms/OSearchResults/index.constant';
import { CheckBox, checkboxVariation } from '@marriott/mi-ui-library';
import { useWindowSize } from '../../hooks';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/OSearchResults/lib/application.constants';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const ShowAvailableFiltersComponent: React.FC<{
  onItemChange: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ onItemChange }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const clickTrackingLoc = 'Phoenix Search Results';
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const [isSliderActive, setIsSliderActive] = useState<boolean>(
    !(searchQueryState[SearchFacetsConstants.unavailableProperties] ?? false)
  );
  const { width } = useWindowSize();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleLabelSelection = (event: any): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const val = isSliderActive;
      setIsSliderActive(!val);
      onItemChange(val);
    }
  };

  const onSliderChange = (): void => {
    const val = isSliderActive;
    setIsSliderActive(!val);
    onItemChange(val);
    setInteractionsSelected({ ...interactionsSelected, availability: true });
  };

  return (
    <StyledAvailabilityDiv>
      <fieldset>
        <StyledAvailabilityFilterHeaderContainerDiv className="t-font-alt-m">
          <legend>
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading mb-0'
              }
            >
              {jsonContent?.availabilityLabel}
            </h4>
          </legend>
        </StyledAvailabilityFilterHeaderContainerDiv>
      </fieldset>
      <div className="availability-checkbox t-font-m color-scheme1">
        <label
          className="t-font-s show-unavailable-properties-checkbox-label"
          tabIndex={-1}
          onKeyDown={(e): void => handleLabelSelection(e)}
        >
          {jsonContent.showAvailableHotelsOnlyLabel}
        </label>
        <CheckBox
          checkboxId="show-unavailable-properties-checkbox"
          onChange={onSliderChange}
          checkboxName="show-unavailable-properties-checkbox"
          variation={checkboxVariation.SWITCH}
          inputClassName="custom_click_track"
          checked={isSliderActive}
          {...{
            custom_click_track_value: `${clickTrackingLoc}| ${jsonContent.showAvailableHotelsOnlyLabel} Selection |internal`,
            tabIndex: -1,
          }}
          children={<span className="ada-hide">{jsonContent.showAvailableHotelsOnlyLabel}</span>}
          ariaLabel={jsonContent.showAvailableHotelsOnlyLabel}
          setTabIndex={-1}
          onKeyDown={(e): void => handleLabelSelection(e)}
        />
      </div>
      <hr aria-hidden className="filter-separator" />
    </StyledAvailabilityDiv>
  );
};
